// usePageViewTracking.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logAppPageView } from 'utilities/AppAnalytics';

const usePageViewTracking = () => {
  const location = useLocation();

  useEffect(() => {
    logAppPageView(`${location.pathname}${location.search}`);
  }, [location]);
};

export default usePageViewTracking;
